import { useState, ChangeEvent, FormEvent } from 'react';
import emailjs from 'emailjs-com';
import "./contact-form.css";

type FormData = {
  name: string;
  email: string;
  message: string;
};

export default function ContactForm() {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    message: '',
  });

  const [showToast, setShowToast] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    formData.message = formData.message.concat(`\n\nFrom: ${formData.email}`);
    console.log('Form submitted:', formData);

    emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID!,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID!,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setShowToast(true);
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setShowToast(false), 3000);
      })
      .catch((error) => {
        console.error('EmailJS error:', error);
      });
    setShowToast(true);
    setTimeout(() => setShowToast(false), 10000);

    setFormData({ name: '', email: '', message: '' });

    // You could add EmailJS, Formspree, or API logic here
  };

  return (
    <div className="contact-form-container">
        <form onSubmit={handleSubmit} className="form-container">
        <input
            name="name"
            type="text"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            className='form-input'
            required
        />
        <input
            name="email"
            type="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            className='form-input'
            required
        />
        <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            rows={5}
            className='form-textarea'
            required
        />
        <button type="submit" className="form-button">
            Send Message
        </button>
        </form>
        {showToast && <div className="toast">Thanks for reaching out!</div>}
    </div>
  );
}
